import { useEffect, useState } from "react"
import Order from "./Order"
import { Box } from "@mui/material"
import { useApiService } from "../hooks/Api/useApiService"
import { useLocation } from "react-router-dom"
import styles from "./Orders.module.css"
import Spinner from "../UI/Spinner/Spinner"
import T from "../hooks/Language/T"

const Orders = () => {
  const [orders, setOrders] = useState([])
  const { postData } = useApiService()
  const location = useLocation()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    postData("transactions/getordersbyuser", {
      user_name: location.state?.user_name || localStorage.getItem("user"),
    })
      .then((data) => {
        setLoading(false)
        setOrders([...data?.orders].sort((a, b) => new Date(b.date_time) - new Date(a.date_time)))
      })
      .catch((error) => {})
  }, [])

  return (
    <T>
      <Box className={styles.orders_container}>
        {/* <Typography variant='h5' align='center' gutterBottom>
        {"My Orders"}
      </Typography> */}
        {!loading ? (
          orders.map((order, index) => (
            <Order
              key={index}
              name={order.name}
              from={order.from}
              to={order.to}
              date_time={order.date_time}
              refundable={order.refundable}
            ></Order>
          ))
        ) : (
          <Spinner />
        )}
      </Box>
    </T>
  )
}

export default Orders
